/**
 * Falls back to a timestamp+random key when crypto.randomUUID is unavailable
 * (older browsers, non-secure contexts) so double-submit dedup never silently
 * goes missing. Shared by every mutation hook that sends an `Idempotency-Key`
 * header (see useSaveWorkbench, useAdvancePreApproval).
 * @returns {string} A unique key suitable for the Idempotency-Key header.
 */
export function generateIdempotencyKey(): string {
  return globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
